import { Link } from "react-router-dom";
import type { Special } from "@/types/content";

interface SpecialCardProps {
  special: Special;
  filmCount: number;
}

export default function SpecialCard({ special, filmCount }: SpecialCardProps) {
  return (
    <Link
      to={`/special/${special.id}`}
      className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all duration-300 hover:-translate-y-1 hover:border-accent-300"
    >
      <div className="relative h-44 w-full overflow-hidden bg-background-200 md:h-48">
        <img
          src={special.cover}
          alt={`${special.title}专题封面`}
          title={`${special.title} 妖精影视专题`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-foreground-950/20 to-transparent" />
        <span className="absolute left-3 top-3 flex items-center gap-1 rounded-md bg-accent-500 px-2 py-0.5 text-xs font-semibold text-primary-950">
          <i className="ri-bookmark-3-fill" />
          专题合集
        </span>
        <div className="absolute bottom-3 left-3 right-3">
          <h3 className="line-clamp-1 font-heading text-lg font-bold text-background-50">
            {special.title}
          </h3>
          <p className="mt-1 flex items-center gap-1 text-xs text-background-200">
            <i className="ri-film-line" />共 {filmCount} 部作品
          </p>
        </div>
      </div>
      <div className="flex flex-1 flex-col p-4">
        <p className="line-clamp-2 text-sm leading-relaxed text-foreground-600">{special.intro}</p>
        <span className="mt-3 flex items-center gap-1 text-sm font-medium text-primary-600 transition-colors group-hover:text-accent-600">
          进入专题
          <i className="ri-arrow-right-line" />
        </span>
      </div>
    </Link>
  );
}